export default __webpack_public_path__ + "CircularPro-Bold.40005560.otf";